'use client';

import { styled } from '@linaria/react';
import { RectangleSkeleton } from '@fe-common-ui/Skeleton';
import HotPopTopicCardSkeleton from '@fe-news/components/molecules/Member/HotPopTopicCardSkeleton';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
  position: relative;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: #000;
`;

const RedBar = styled.div`
  width: 5px;
  height: 22px;
  background-color: #e03f19;
  position: absolute;
  top: 7px;
  left: -25px;
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 19px;
`;

const HotPopTopicList = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;

const HotPopTopicTrackingListSkeleton = () => {
  return (
    <Container>
      <RedBar />
      <Title>
        <h3>熱門追蹤時事</h3>
        <TitleContainer>
          <RectangleSkeleton width={85} height={20} />
        </TitleContainer>
      </Title>
      <HotPopTopicList>
        {Array.from({ length: 5 }).map((_, index) => (
          <HotPopTopicCardSkeleton key={index} />
        ))}
      </HotPopTopicList>
    </Container>
  );
};

export default HotPopTopicTrackingListSkeleton;
